import { Icon, Input } from '@data-products-and-ai/react-components';
import { ChangeEvent, FC } from 'react';

import '@/components/Search/Search.scss';

interface SearchProps {
  value: string;
  label?: string;
  placeholder: string;
  disabled?: boolean;
  onSearch: (searchTerm: string) => void;
}

export const Search: FC<SearchProps> = ({
  value,
  placeholder,
  label,
  disabled = false,
  onSearch,
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onSearch?.(event.target.value);
  };

  return (
    <div className="search">
      <Input
        {...(label && { label })}
        id="search"
        className="search__input"
        defaultValue={value}
        disabled={disabled}
        placeholder={placeholder}
        onChange={handleChange}
      />
      <Icon icon="IconSearch" color="var(--color-default)" iconSize={0.75} />
    </div>
  );
};
